import * as actionTypes from "./actionTypes";
import { updateObject } from "../../util/updateObject";
import { initialSelectedAree } from "./helper";

const initialState = {
  areeDiOrigineChiamate: {
    data: [],
    lastUpdated: "",
    loading: false,
  },
  selectedAree: initialSelectedAree,
  createAreeLoading: false,
  exportAreeLoading: false,
  importAreeLoading: false,
  currentItemList: [],
};

const setAreeDiOrigineChiamate = (state, action) => {
  return updateObject(state, {
    areeDiOrigineChiamate: updateObject(state.areeDiOrigineChiamate, {
      [action.key]: action.value,
    }),
  });
};

const setExportAreeLoading = (state, action) => {
  return updateObject(state, {
    exportAreeLoading: action.value,
  });
};

const setImportAreeLoading = (state, action) => {
  return updateObject(state, {
    importAreeLoading: action.value,
  });
};

const setCreateAreeLoading = (state, action) => {
  return updateObject(state, {
    createAreeLoading: action.value,
  });
};

const setCurrentAree = (state, action) => {
  return updateObject(state, {
    selectedAree: updateObject(state.selectedAree, {
      [action.key]: action.value,
    }),
  });
};

const setCurrentItemList = (state, action) => {
  return updateObject(state, {
    currentItemList: updateObject(state.currentItemList, {
      [action.key]: action.value,
    }),
  });
};

const areeDiOrigineChiamateReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_ORIGINE_CHIAMATE_DATA_AND_LOADING:
      return setAreeDiOrigineChiamate(state, action);
    case actionTypes.EXPORT_AREE_LOADING:
      return setExportAreeLoading(state, action);
    case actionTypes.IMPORT_AREE_LOADING:
      return setImportAreeLoading(state, action);
    case actionTypes.CREATE_UPDATE_DELETE_AREE:
      return setCreateAreeLoading(state, action);
    case actionTypes.GET_CURRENT_AREE:
      return setCurrentAree(state, action);
    case actionTypes.GET_CURRENT_ITEM_LIST:
      return setCurrentItemList(state, action);
    default:
      return state;
  }
};

export default areeDiOrigineChiamateReducer;
